module.exports = __webpack_public_path__ + "static/media/logoFilled-red.82320b08.svg";